/**
 * @file lib/api.js
 * @description Shared authenticated fetch helper. Same pattern the pages have
 * used inline (credentials: include + silent 401->refresh->retry), centralized
 * so the Customer Butler screens don't each re-implement it.
 */
export const API = process.env.REACT_APP_API_URL || '/api';

/** fetch with cookies + one transparent token refresh on 401. */
export async function authFetch(url, options = {}) {
  const opts = {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  };
  let response = await fetch(url, opts);
  if (response.status === 401) {
    const refresh = await fetch(`${API}/auth/refresh`, { method: 'POST', credentials: 'include' });
    if (refresh.ok) response = await fetch(url, opts);
  }
  return response;
}

/** GET + parse, returning the envelope's data (or [] / null). */
export async function apiGet(path) {
  const res = await authFetch(`${API}${path}`);
  if (!res.ok) throw new Error((await safeError(res)) || `GET ${path} failed`);
  const json = await res.json();
  return json.data !== undefined ? json.data : json;
}

/** Send a body with a method; returns { ok, data, error }. */
export async function apiSend(path, method, body) {
  const res = await authFetch(`${API}${path}`, {
    method,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let json = null;
  try { json = await res.json(); } catch (e) { /* no body */ }
  return {
    ok: res.ok,
    data: json && json.data !== undefined ? json.data : json,
    error: json && json.error ? json.error : null,
    status: res.status,
  };
}

async function safeError(res) {
  try {
    const j = await res.json();
    return j.error && j.error.message;
  } catch (e) {
    return null;
  }
}
